import { defineComponent as n, useId as d, createBlock as i, openBlock as r, normalizeProps as c, guardReactiveProps as l, unref as a, withCtx as m, createElementVNode as f, createElementBlock as p, createCommentVNode as _, renderSlot as o } from "vue";
import { useBindCx as u } from "@scalar/use-hooks/useBindCx";
import h from "./ScalarCardSection.vue.js";
import { useCardHeading as x } from "./useCardHeading.js";
const C = ["id"], k = {
  key: 0,
  class: "flex"
}, B = {}, H = /* @__PURE__ */ n({
  ...B,
  inheritAttrs: !1,
  __name: "ScalarCardHeader",
  setup($) {
    const { cx: s } = u(), t = d();
    return x(t), (e, g) => (r(), i(h, c(l(
      a(s)(
        "scalar-card-header leading-[22px] font-medium py-[6.75px] px-3 shrink-0"
      )
    )), {
      default: m(() => [
        f("div", {
          id: a(t),
          class: "scalar-card-header-title min-w-0 flex-1 truncate"
        }, [
          o(e.$slots, "default")
        ], 8, C),
        e.$slots.actions ? (r(), p("div", k, [
          o(e.$slots, "actions")
        ])) : _("", !0)
      ]),
      _: 3
    }, 16));
  }
});
export {
  H as default
};
